const NumberHeaderInput = ({ value, onChange, onFocus, onClick, readOnly, color }) => (
    <input
      className="customHead-input"
      placeholder="یک عنوان وارد کنید"
      style={{
        border: 'none',
        outline: 'none',
        userSelect: 'text',
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        width: '100%',
        fontSize: '16px',
        fontWeight: 700,
        lineHeight: 1.45,
        color
      }}
      readOnly={readOnly}
      value={value}
      onChange={onChange}
      onClick={onClick}
      onFocus={readOnly ? null : onFocus}
    />
  );
  
  export default NumberHeaderInput;
  